"use strict";

exports["default"] = function (obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
};

exports.__esModule = true;


/*****************
 ** WEBPACK FOOTER
 ** /home/rengasturku/nettivanne/~/babel-runtime/helpers/interop-require-default.js
 ** module id = 10
 ** module chunks = 0 1 2 3 4 5 6 7 8 9
 **/